<template>
  <subscriber-layout>
    <router-view></router-view>
  </subscriber-layout>
</template>

<script>
export default {
  computed: {
    subscriberId() {
        return localStorage.getItem("subscriber_id");
      },
  },
  watch: {
    $route(to, from) {
      console.log(to);
      console.log(from);
      this.checkExpiry();
    }
  },
  methods: {
    checkExpiry() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResponseData.SystemSuspended == 1) {
            self.$router.push("/inactive-account");
          }
        })
        .catch(() => { });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultDesc == "that token is invalid") {
            self.$router.push("/login");
          }
        })
        .catch(() => { });
    },
  },
  created() {
    this.getAccounts();
    // this.getUserDetails();
  },
};
</script>

<style lang="scss" scoped></style>